import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { LandPagesService } from 'src/app/services/landpages/landpages.service'
import { ModalTooltipComponent } from '../../components/modals/modal-tooltip/modal-tooltip.component'

@Component({
	selector: 'app-parceiros-insurance',
	templateUrl: './parceiros-insurance.component.html',
	styleUrls: ['./parceiros-insurance.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class ParceirosInsuranceComponent implements OnInit {
    slideConfig = {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        infinite: true,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
    }

    informationCard = {
        title: 'Conheça os seguros Allianz!',
        text: 'A Allianz oferece diferentes opções para proteger seu veículo, sua residência, sua empresa ou sua família. Selecione o produto que deseja e solicite uma cotação personalizada para conhecer as opções de cobertura e proteção disponíveis.'
    }

	hubUtm = ''
	errorZipcode = false
	disabled = true
	step = 1
	formFeedback = {
		title: '',
		subtitle: '',
	}
	partner = this.activatedRouter.snapshot.paramMap.get('parceiro')

	slug: string = ''

	data: any = null
	tabs = [
		{
			title: 'Vida',
			active: false,
			content: 'life',
		},
		{
			title: 'Residência',
			active: false,
			content: 'residence',
		},
		{
			title: 'Auto',
			active: true,
			content: 'auto',
		},
	]
    // ARTIGOS BLOG
    blogSection: any = null
    // PERGUNTAS FREQUENTES
    faqSection: any = null
    activeFaqIndex: number | null = null
    toggleFaq(index: number): void {
        this.activeFaqIndex = this.activeFaqIndex === index ? null : index
    }

	constructor(
		private modal: NgbModal,
		private landpageService: LandPagesService,
		public activatedRouter: ActivatedRoute,
		public router: Router

	) {}

	ngOnInit(): void {

		this.getPartnerData()
        this.slug = window.location.pathname

		if(this.partner === 'xp-investimentos' || this.partner === 'xp-colaboradores') {
            const content = document.querySelector('.parceiros');
            const header = document.querySelector('header');
            const footer = document.querySelector('footer');

            content?.classList.add('xp-content')
            header?.classList.add('xp-content')
            footer?.classList.add('xp-content')
        }
	}

	getPartnerData() {
		const payload = {
			partner: this.activatedRouter.snapshot.paramMap.get('parceiro') || 'allianz',
			uuid: this.activatedRouter.snapshot.routeConfig?.data?.title === 'Seguro Allianz - Parceiro Preview! Faça sua cotação' ? this.activatedRouter.snapshot?.paramMap?.get('uuid') : ''
		}
		const self = this

		self.landpageService.getPartnersData(payload, this.activatedRouter.snapshot.routeConfig?.data?.title === 'Seguro Allianz - Parceiro Preview! Faça sua cotação' ? `${payload.partner}/${payload.uuid}/preview` : `${payload.partner}`, {
			fnSuccess(data?: any) {
				if (data) {
					self.data = data.filter((element: any) => element !== null)

                    const knowledgeSection = data.find(
                        (section: any) => section.handle === 'knowledge_section'
                    )

                    if (knowledgeSection?.data) {
                        self.blogSection = {
                            fragment: knowledgeSection.fragment,
                            title: knowledgeSection.data.text,
                            subtitle: knowledgeSection.data.description,
                            backgroundColor:
                                knowledgeSection.data.background_color || '#FFFFFF',

                            cards: (knowledgeSection.data.articles || []).map(
                                (article: any) => ({
                                    // Se image for null ou vazia, utiliza link_image
                                    image: article.image || article.link_image,
                                    altText: article.alt_text || '',
                                    label: article.text,
                                    text: article.description,
                                    link: article.link_url,
                                    linkText: article.link_text || 'Ler artigo completo',
                                    linkExternal: article.link_external,
                                })
                            ),
                        }
                    }

                    const faqSection = data.find(
                        (section: any) => section.handle === 'faq_section'
                    )

                    if (faqSection?.data) {
                        self.faqSection = {
                            fragment: faqSection.fragment,
                            title: faqSection.data.text,
                            subtitle: faqSection.data.description,
                            backgroundColor:
                                faqSection.data.background_color || '#DFEFF2',

                            items: (faqSection.data.items || []).map(
                                (item: any) => ({
                                    question: item.question,
                                    answer: item.answer,
                                    backgroundColor:
                                        item.background_color || '#FFFFFF',
                                })
                            ),
                        }
                    }
				}
			},
			fnError(error) {
				self.router.navigate(['/not-found'])
			},
			fnFinalized() {},
		})
	}

	openModal(): void {
		this.modal.open(ModalTooltipComponent, {
			modalDialogClass: 'modal-tooltip',
		})
	}
}
